import { Button } from '@/ui';

import type { FC, ReactNode } from 'react';

import { MENTO_LOGO_URL } from '@/components/MentoCal/constants';

interface AssistantPageShellProps {
  children: ReactNode;
  /** Header controls for a signed-in assistant: member switcher, sign out. */
  headerActions?: ReactNode;
}

export const AssistantPageShell: FC<AssistantPageShellProps> = ({
  children,
  headerActions,
}) => (
  <main className="min-h-screen bg-sage-100 px-4 py-8">
    <div className="mx-auto flex w-full max-w-2xl flex-col gap-6">
      <header className="flex flex-wrap items-center justify-between gap-4">
        <img alt="Mento" className="h-8" src={MENTO_LOGO_URL} />
        {headerActions ? (
          <div className="flex flex-wrap items-center gap-3">
            {headerActions}
          </div>
        ) : null}
      </header>
      <section className="rounded-xl border border-cement-300 bg-white p-6">
        {children}
      </section>
    </div>
  </main>
);

interface SignOutButtonProps {
  disabled?: boolean;
  onSignOut: () => void;
}

export const AssistantSignOutButton: FC<SignOutButtonProps> = ({
  disabled = false,
  onSignOut,
}) => (
  <Button
    color="gray"
    disabled={disabled}
    size="small"
    variant="outlined"
    onClick={onSignOut}
  >
    Sign out
  </Button>
);
